<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-9 col-sm-1">
              <v-text-field label="Nome" v-model="current.nome" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Código" v-model="current.codigo" outlined dense></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/pop" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("pop fail");
        });
    },
    save: function() {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/pop", this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("POP cadastrado com sucesso!");
            router.push({ path: "/pop" });
          });
      } else {
        api
          .put("/pop/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("POP atualizado com sucesso!");
            router.push({ path: "/pop" });
          });
      }
    }
  }
};
</script>